import React, { useEffect, useState } from "react";
import "../App.css";
import info from "../assets/Frame.svg";
import api from "../api/api";
import DateModal from "./Modals/dateModals";
import { faL } from "@fortawesome/free-solid-svg-icons";
import UserDetails from "./Modals/userDetails";
import StatusShow from "./Modals/StatusShow";
import dropdown from '../assets/dropdown.svg'
const RecapTable = ({ data,startDate,endDate,fetchData ,setSelectedRows,selectedRows}) => {
    const [modaldateData, setModaldateData] = useState(null);
    const [isdateModalOpen, setIsdateModalOpen] = useState(false);
    const [rowuserDetails,setrowUserDetails]=useState(null);
    const [isUsermodal,setIsUserModalOpen]=useState(false);
    const [employedata, setEmployeeData] = useState(null);
    const [pickedDate,setPickedDate]=useState(null);
    const [statusDetails,setStatusDetails]=useState(null);
    const [statusShowModal,setStatusShowModal]=useState(false)
    const hoursOptions = ["4hrs", "6hrs", "8hrs", "10hrs", "12hrs"];
const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];


const [selectAll, setSelectAll] = useState(false);
useEffect(() => {
  if (selectAll) {
    const allSelected = Object.values(data.emp_report)
      .filter(emp =>
        emp.activity.some(act =>
          act.work_details.some(wd => wd.sage_status !== "Y")
        )
      )
      .map(emp => ({
        emp_id: emp.emp_id,
        work_ids: emp.activity.flatMap(act =>
          act.work_details
            .filter(wd => wd.sage_status !== "Y")
            .map(wd => wd.id)
        )
      }));

    setSelectedRows(allSelected);
  }
}, [selectAll, data]);




const toggleRow = (employee) => {
  const workIds = employee.activity.flatMap(act =>
    act.work_details
      .filter(wd => wd.sage_status !== "Y")
      .map(wd => wd.id)
  );

  if (workIds.length === 0) return;

  setSelectedRows(prev => {
    const exists = prev.some(sel => sel.emp_id === employee.emp_id);

    if (exists) {
      setSelectAll(false);
      return prev.filter(sel => sel.emp_id !== employee.emp_id);
    } else {
      const newSelected = [...prev, { emp_id: employee.emp_id, work_ids: workIds }];

      const selectableCount = Object.values(data.emp_report)
        .filter(emp =>
          emp.activity.some(act =>
            act.work_details.some(wd => wd.sage_status !== "Y")
          )
        ).length;

      if (newSelected.length === selectableCount) {
        setSelectAll(true);
      }

      return newSelected;
    }
  });
};



    if (!data || !data.emp_report || Object.keys(data.emp_report).length === 0) {
        return (
                        <div className="w-[98%]  mx-2  bg-white shadow-lg border-2 p-4  rounded-[10PX] ">
            <table className="w-full border-collapse">
                <thead >
                    <tr className="border-b  border-gray-300 text-[#900] bg-[#eee]">
         

                        <th className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[15%] text-start">Employee Name</th>
                        <th className="p-2 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[15%] text-start">Total Hours</th>
                        <th className="p-2 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[15%] text-start">Total Per Diem</th>
                        {daysOfWeek.map((day) => (
                            <th key={day} className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[10%] text-start">{day}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={3 + daysOfWeek.length} className="p-4 text-center text-gray-500">
                            No data found
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        );
    }
    

    const formatHours = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        if (hours === 0 && minutes === 0) return "0hr";
        
        const decimalHours = hours + minutes / 60;
        const formattedHours = decimalHours % 1 === 0 ? decimalHours : decimalHours.toFixed(1);
        
        return `${formattedHours}hr${decimalHours > 1 ? "s" : ""}`;
    };
    
    const GetUserDetails=async(employee)=>{
        console.log('Employee',employee)
        setEmployeeData(employee);
        try {
            const response = await api.get("/v1/timesheets/search", {
                params: {
                    start_date: startDate,
                    company_id: 1,
                    end_date:endDate,
                    supervisor_id: employee.emp_id,
                    
                },
            });
    
            if (response.status === 200) {
                console.log(response.data);
                setrowUserDetails(response.data);
          
            } else {
                console.log('Error: Response status not 200', response.status);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
    
        }
    };
    const toDecimalHours = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return +(hours + minutes / 60).toFixed(2); // round to 2 decimal places
};

    const handleSelectDateClick=async(formatedDate,employee)=>{
        setPickedDate(formatedDate)
        setModaldateData(employee);
        try {
            const response = await api.get("/v1/timesheets/search", {
                params: {
                    start_date: formatedDate,
                    company_id: 2,
                    supervisor_id: employee.emp_id,
                },
            });
    
            if (response.status === 200) {
                console.log(response.data,'responseData')
              
            } else {
                console.log('Error: Response status not 200', response.status);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
    
        }
    };
    const CloseModalWi=()=>{
        setIsdateModalOpen(false)
    }

    const CloseUserdetailsModal=()=>{
        setIsUserModalOpen(false)
    }

    const handleStatusShow=(employee)=>{
      setStatusDetails(employee)
      setStatusShowModal(true)
    }

    return (
        <div className="w-full flex justify-center">
            <div className="w-full max-w-full mx-2  bg-white shadow-lg border-2 p-4  rounded-[10PX] overflow-x-auto custom-scrollbar">
                <table className="w-full min-w-[1000px] border-collapse ">
                    <thead>
                        <tr className="border-b border-gray-300 text-[#900] bg-gray-100">
                                           <th className="p-3 w-[5%] text-center">
  <input
    type="checkbox"
    checked={selectAll}
  onChange={(e) => {
  const checked = e.target.checked;

  if (!checked) {
    // Explicitly deselect all
    setSelectedRows([]);
  }

  setSelectAll(checked);
}}

  />
</th>
                            <th className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[35%] text-start">Employee Name</th>
                            <th className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[22%] text-center">Total Hours</th>
                            <th className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[22%] text-center">Total Per Diem</th>
                            {daysOfWeek.map((day) => (
                                <th key={day} className="p-3 font-Font1 text-[12px] font-semibold tracking-[0.2px] uppercase w-[10%] text-start">{day}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Object.values(data.emp_report).map((employee, index) => {
                            const { emp_name, total_perdim, total_hours, activity } = employee;
                       const isEquipment = employee.activity?.some(act =>
  act.work_details?.some(wd => wd.etype === "EQP")
);
                            return (
                                <tr key={index} className="border-b border-gray-200 ">
                          <td className="p-3 w-[5%] text-center">
  {employee.activity.some(act => 
    act.work_details.some(wd => wd.sage_status !== "Y")
  ) ? (
    <input
      type="checkbox"
      checked={selectedRows.some(sel => sel.emp_id === employee.emp_id)}
      onChange={() => toggleRow(employee)}
    />
  ) : null}
</td>


                                    <td className="p-3 font-semibold text-start ">
                                        <div className="flex gap-2 items-center ">
                                            <div>
                                                <div className="flex flex-wrap items-center gap-1">
                                                    <span onClick={()=>{GetUserDetails(employee);setIsUserModalOpen(true)}} className="cursor-pointer font-Font1 text-sm font-semibold"> {emp_name.length > 14 ? emp_name.substring(0, 14) + '...' : emp_name}</span>
                                                    <span
                                                        className="px-2 font-inter py-[2px] text-[#8B1818] text-[12px] font-medium"
                                                        style={{
                                                            background: "rgba(139, 24, 24, 0.10)",
                                                            borderRadius: "9999px"
                                                        }}
                                                    >
                                                        {employee.emp_id}
                                                    </span>
                                                </div>
                                                <div className="text-[13px] font-normal text-gray-500">{employee.classification_name}</div>
                                               { employee.activity.some(act => 
    act.work_details.some(wd => wd.sage_status === "Y")
  )&&<> <span className="text-[10px] px-1 bg-green-100 text-green-800 rounded-full font-medium">Submitted</span>
          </>}
                                            </div>
                                            <img onClick={()=>handleStatusShow(employee)} src={info} alt="Info" className=" h-4 cursor-pointer" />
                                        </div>
                                    </td>
                                    <td className=" text-gray-900 text-center font-inter text-sm text-[#374151]"> 
                                        {/* {total_hours?.split(':').slice(0, 2).join(':')} */}
                                          {toDecimalHours(total_hours)}
                                        </td>
                                    <td className=" text-gray-900 text-center font-inter text-sm text-[#374151] pr-3">{total_perdim ? `${total_perdim}` : "0"}</td>
                                    {daysOfWeek.map((day, dayIndex) => {
                    // Calculate the date for the current day based on the startDate
                    const currentDate = new Date(startDate);
                    currentDate.setDate(currentDate.getDate() + dayIndex);
                    const formattedDate = currentDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
                    const dailyActivity = activity.find((act) => act.date === formattedDate);
//                  const dailyHours = dailyActivity && dailyActivity.work_details && dailyActivity.work_details.length > 0
//   ? (() => {
//       let totalMinutes = 0;
//       dailyActivity.work_details.forEach(detail => {
//         const [hrs, mins] = detail.hours.split(":").map(Number);
//         totalMinutes += hrs * 60 + mins;
//       });

//       const totalHours = Math.floor(totalMinutes / 60);
//       const remainingMinutes = totalMinutes % 60;
//       return `${totalHours}${remainingMinutes > 0 ? '.' + (remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes) : ''}`;
//     })()
//   : "00";

          const dailyHours = dailyActivity && dailyActivity.work_details && dailyActivity.work_details.length > 0
  ? (() => {
      let totalMinutes = 0;
      dailyActivity.work_details.forEach(detail => {
        const [hrs, mins] = detail.hours.split(":").map(Number);
        totalMinutes += hrs * 60 + mins;
      });
      const decimalHours = +(totalMinutes / 60).toFixed(2);
      return decimalHours;
    })()
  : 0;
      
                   
// daily_hours
                    return (
                        <td key={day} onClick={() => {
                            handleSelectDateClick(formattedDate, employee);
                            setIsdateModalOpen(true); // This opens the modal (or sets its state to open)
                          }}
                            className="p-1 text-start"
                            
                            >
                          
                            <div style={{justifyContent:'center',display:'flex',alignItems:'center'}}    className="py-1 pl-[2px] flex items-center justity-between border font-inter text-sm text-[#374151] rounded max-w-[100%] min-w-[79px] bg-[#F9FAFB] cursor-pointer focus:outline-none" >
                            <div  value={dailyHours}>{dailyHours} hrs</div><img src={dropdown} alt="%$"/>
                            </div>
                        </td>
                    );
                                       })}

                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {statusShowModal&&<StatusShow statusDetails={statusDetails} setStatusShowModal={setStatusShowModal} />}
            {isdateModalOpen&&<DateModal pickedDate={pickedDate} fetchData={fetchData} passeddata={modaldateData} closeModal={CloseModalWi} />}
            {isUsermodal && <UserDetails employedata={employedata} userdetails={rowuserDetails} startDate={startDate} endDate={endDate}  CloseUserdetailsModal={CloseUserdetailsModal} />}

        </div>
    );
};

export default RecapTable;
